import {Component} from '@angular/core';
import {SpreadsheetQueryFactory} from "@features/spreadsheet/spreadsheet-query";
import {MagicLinkModel} from "@shared/models/platform-tool-models";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";

@Component({
    standalone: false,
    selector: 'app-abbreviations',
  templateUrl: './abbreviations.component.html',
  styleUrl: './abbreviations.component.scss'
})

export class AbbreviationsComponent {
  platformLink: MagicLinkModel = null;
  isFetchStepsComplete: boolean = false;
  abbreviations: Abbreviation[] = [];

  constructor(
    private platformQueryService: PlatformQueryService,
    private fuseSplashScreenService: FuseSplashScreenService
  ) {}

  ngOnInit(): void {
    this.fetchAbbreviations();
  }
  fetchAbbreviations() {
    this.isFetchStepsComplete = false;
    const getAbbreviationsListsQuery = SpreadsheetQueryFactory.fetchAbbreviationsQuery();

    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(getAbbreviationsListsQuery).subscribe((res) => {
      this.abbreviations = res.fieldValues["Abbreviations"] ? res.fieldValues["Abbreviations"] : [];
      this.fuseSplashScreenService.hide();
      this.isFetchStepsComplete = true;
    });
  }
}
interface Abbreviation {
  Id: string;
  ShortName: string;
  FullName: string;
  Elaboration: string;
  ScenarioType: string;
  Version: string;
}
